// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pyBT","content":"styles_content__3pM86"};